import { render } from "./CategoryOneFileUploadDialog.vue?vue&type=template&id=650bc706&scoped=true"
import script from "./CategoryOneFileUploadDialog.vue?vue&type=script&lang=ts"
export * from "./CategoryOneFileUploadDialog.vue?vue&type=script&lang=ts"

import "./CategoryOneFileUploadDialog.vue?vue&type=style&index=0&id=650bc706&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-650bc706"

export default script
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QDialog});
